import type { PaymentTransactionDataQuality } from '@pillar-portal/api-types';

export interface TransactionDataQualityPresentation {
    tooltip: string;
    severityClassName: string;
    ariaLabel: string;
}

export function getTransactionDataQualityPresentation(
    dataQuality: PaymentTransactionDataQuality
): TransactionDataQualityPresentation {
    return {
        tooltip: dataQuality.issues
            .map((issue) => `${issue.severity.toUpperCase()}: ${issue.message}`)
            .join('\n'),
        severityClassName:
            dataQuality.severity === 'error' ? 'h-4 w-4 text-red-600' : 'h-4 w-4 text-yellow-500',
        ariaLabel: `${dataQuality.severity} data quality issue`,
    };
}
